import classNames from 'classnames'

/**
 * Renders a Font Awesome icon definition (e.g. `faArrowRight`) as an inline SVG, with the same markup
 * as `@fortawesome/react-fontawesome`.
 *
 * Used instead of `FontAwesomeIcon`, whose runtime (~70 KB) shipped on every page and only injected
 * its sizing CSS after hydration, so server-rendered icons briefly painted at full width. Sizing comes
 * from the `.svg-inline--fa` rule in `styles/_Base.scss`.
 */
function Icon({ icon, className, ...rest }) {
  const { prefix, iconName } = icon
  const [width, height, , , path] = icon.icon

  return (
    <svg
      data-prefix={prefix}
      data-icon={iconName}
      className={classNames('svg-inline--fa', `fa-${iconName}`, className)}
      role="img"
      viewBox={`0 0 ${width} ${height}`}
      aria-hidden="true"
      {...rest}
    >
      <path fill="currentColor" d={Array.isArray(path) ? path.join(' ') : path} />
    </svg>
  )
}

export default Icon
